import classNames from 'classnames'
import { FieldCounter } from '../field-counter'
import { FieldHeader } from '../field-header'
import { FieldHelper } from '../field-helper'
import { FieldStatus } from '../types'
import styles from './Field.module.scss'
import type { FieldProps } from './types'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Field = ({
  className,
  label,
  secondaryLabel,
  error,
  withInfo,
  counter,
  children,
  helperLabel,
  helperWithIcon,
  limit,
  style,
  fieldHeaderId,
  fieldErrorId,
  fieldHelperId,
}: FieldProps) => {
  const finalHelperLabel = error || helperLabel
  const fieldHelperElementId = error
    ? fieldErrorId
      ? { id: fieldErrorId }
      : {}
    : fieldHelperId
      ? { id: fieldHelperId }
      : {}
  const fieldHeaderElementId = fieldHeaderId ? { id: fieldHeaderId } : {}
  return (
    <div
      className={classNames(styles['pintxo-field-container'], className)}
      data-status="status"
      style={style}
    >
      {(label || secondaryLabel) && (
        <FieldHeader
          status={error ? FieldStatus.critical : FieldStatus.neutral}
          className={styles['pintxo-field-container__label']}
          label={label}
          secondaryLabel={secondaryLabel}
          withInfo={withInfo}
          counter={counter}
          {...fieldHeaderElementId}
        />
      )}
      {children}
      <div className={styles['pintxo-field-container__footer']}>
        <div className={styles['pintxo-field-container__footer__left']}>
          {finalHelperLabel && (
            <FieldHelper
              label={finalHelperLabel}
              withIcon={helperWithIcon}
              status={error ? FieldStatus.critical : FieldStatus.neutral}
              {...fieldHelperElementId}
            />
          )}
        </div>
        <div className={styles['pintxo-field-container__footer__right']}>
          {!!limit && (
            <FieldCounter
              status={error ? FieldStatus.critical : FieldStatus.neutral}
              counter={counter}
              limit={limit}
              className={styles['pintxo-field-container__footer__counter']}
            />
          )}
        </div>
      </div>
    </div>
  )
}
export default Field
